import api from '@/api';
import {
  GPPendingActivityListRequest,
  GPPendingActivityListResponse,
} from './pending-activities.types';

const BASE = '/visual-management/pending-activities';

export default {
  async list(params: GPPendingActivityListRequest) {
    const result = (await api.get(BASE, params)) as unknown;
    return result as GPPendingActivityListResponse;
  },
};
